import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  initialised = false;
  featureFlags: Partial<Record<string, boolean>> = {};

  loadedConfig: Record<string, any> = {};
  constructor(private http: HttpClient) {
    this.loadConfig();
    this.initialise();
  }

  loadConfig(): void {
    this.http
      .get('/config.json')
      .pipe(catchError(() => of({})))
      .subscribe({
        next: (val) => {
          this.loadedConfig = val;
        },
      });
  }

  initialise(): void {
    posthog.onFeatureFlags(
      (_flags: string[], variants: Record<string, string | boolean>) => {
        this.featureFlags = variants as Record<string, boolean>;
        this.initialised = true;
      }
    );
  }

  isFeatureFlagEnabled(
    featureFlagKey: string,
    configFallbackKey?: string
  ): boolean {
    // Save calls to posthog outside of initial load
    if (this.initialised) {
      return this.featureFlags[featureFlagKey] ?? false;
    }

    return posthog.isFeatureEnabled(featureFlagKey) ?? false;
  }

  isFeatureFlagEnabled$(
    featureFlagKey: string,
    configFallbackKey?: string
  ): Observable<boolean> {
    // Save calls to posthog outside of initial load
    if (this.initialised) {
      return of(this.featureFlags[featureFlagKey] ?? false);
    }

    return of(posthog.isFeatureEnabled(featureFlagKey) ?? false);
  }
}
